<google-map #map [height]="height" [width]="width" [zoom]="zoom" [options]="mapOptions">
  <ng-container *ngIf="markers">
    <ng-container *ngFor="let marker of markers; trackBy: trackByMapMarker">
      <app-map-marker [markerIn]="marker" [mapElement]="map.googleMap"> </app-map-marker>
    </ng-container>
  </ng-container>
</google-map>
